import React, { useState } from 'react';
import ArtifactTile from './ArtifactTile';
import './Project.css';

interface Artifact {
  id: string;
  type: string;
  content: string;
  created_at: string;
  version: number;
  project_id: string;
  user_id: string;
}

interface ProjectArtifactsProps {
  artifacts: Artifact[];
  onEdit: (artifact: Artifact) => void;
  onDelete: (artifactId: string) => void;
  editingArtifact: string | null;
  editedArtifactContent: string;
  onEditContentChange: (content: string) => void;
  onSave: (artifactId: string, content: string) => void;
  onCancelEdit: () => void;
  deletingArtifact: string | null;
  getArtifactIcon: (type: string) => React.ReactNode;
}

const ProjectArtifacts: React.FC<ProjectArtifactsProps> = ({
  artifacts,
  onEdit,
  onDelete,
  editingArtifact,
  editedArtifactContent,
  onEditContentChange,
  onSave,
  onCancelEdit,
  deletingArtifact,
  getArtifactIcon,
}) => {
  const [expandedArtifact, setExpandedArtifact] = useState<string | null>(null);

  const handleExpand = (artifactId: string) => {
    // If clicking the same artifact, do nothing (keep it expanded)
    // If clicking a different artifact, switch to that one
    if (expandedArtifact !== artifactId) {
      setExpandedArtifact(artifactId);
    }
  };

  const expandedArtifactData = artifacts.find(a => a.id === expandedArtifact);

  return (
    <div className="artifacts-content">
      <div className="artifacts-container">
        <div className="artifacts-grid">
          {artifacts.map((artifact) => (
            <div key={artifact.id} className="artifact-tile-wrapper">
              <ArtifactTile
                artifact={artifact}
                onEdit={onEdit}
                onDelete={onDelete}
                editingArtifact={editingArtifact}
                editedArtifactContent={editedArtifactContent}
                onEditContentChange={onEditContentChange}
                onSave={onSave}
                onCancelEdit={onCancelEdit}
                deletingArtifact={deletingArtifact}
                getArtifactIcon={getArtifactIcon}
                isExpanded={expandedArtifact === artifact.id}
                onExpand={handleExpand}
              />
            </div>
          ))}
        </div>
        {expandedArtifactData && (
          <div className="expanded-artifact-container">
            <div className="expanded-artifact-content">
              <ArtifactTile
                artifact={expandedArtifactData}
                onEdit={onEdit}
                onDelete={onDelete}
                editingArtifact={editingArtifact}
                editedArtifactContent={editedArtifactContent}
                onEditContentChange={onEditContentChange}
                onSave={onSave}
                onCancelEdit={onCancelEdit}
                deletingArtifact={deletingArtifact}
                getArtifactIcon={getArtifactIcon}
                isExpanded={true}
                onExpand={handleExpand}
                isFullWidth={true}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectArtifacts;
